// extracted by mini-css-extract-plugin
export var column = "_r2-0";
export var divider = "_r2-2";
export var timePicker = "_r2-1";